import { render, staticRenderFns } from "./UpdateMyWaitlist.vue?vue&type=template&id=e2e285c8"
import script from "./UpdateMyWaitlist.vue?vue&type=script&lang=js"
export * from "./UpdateMyWaitlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports